import React from 'react';
import { Animated, Text } from 'react-native';
// TODO (yusei) make this work in native
import SwipeableViews from 'react-swipeable-views';

import R from 'common/res/R';

export const CONTENT_FONT_SIZE = R.typography.fontSize.medium;
export const CONTENT_LINE_HEIGHT = R.typography.fontSize.big;
export const CONTENT_PADDING_VERTICAL = R.spacing.xxs;
export const CONTENT_HEIGHT =
  CONTENT_LINE_HEIGHT + CONTENT_PADDING_VERTICAL * 2;

class SwipeablePicker extends React.Component {
  state = {
    index: this.props.index,
    position: new Animated.Value(this.props.index),
  };

  handleChangeIndex = index => {
    if (this.props.onChange) {
      this.props.onChange(this.props.timeSection[index]);
    }

    this.setState({ index });
  };

  handleSwitch = (index, type) => {
    if (type === 'end') {
      Animated.spring(this.state.position, { toValue: index }).start();
      return;
    }
    this.state.position.setValue(index);
  };

  // all styles need to be be object as this libs use Object.assign
  // also all styles need to be valid in web (no marginHorizontal, aspectRatio,
  // etc)
  render() {
    const { timeSection } = this.props;
    const { index, position } = this.state;

    return (
      <SwipeableViews
        index={index}
        style={{
          backgroundColor: R.color.uiLightPrimary,
          // padding needs to be unified to make swiping behavior works
          // i don't know why
          padding: CONTENT_HEIGHT,
        }}
        onChangeIndex={this.handleChangeIndex}
        onSwitching={this.handleSwitch}
        axis="y"
        containerStyle={{
          height: CONTENT_HEIGHT,
        }}
      >
        {timeSection.map((hour, currentIndex) => {
          const inputRange = timeSection.map((_, i) => i);

          const scale = position.interpolate({
            inputRange,
            outputRange: inputRange.map(i => {
              return currentIndex === i ? 1 : 0.7;
            }),
          });
          const opacity = position.interpolate({
            inputRange,
            outputRange: inputRange.map(i => {
              return currentIndex === i ? 1 : 0.3;
            }),
          });

          return (
            <Animated.View
              key={String(currentIndex)}
              style={{
                opacity,
                transform: [{ scale }],
                paddingTop: CONTENT_PADDING_VERTICAL,
                paddingBottom: CONTENT_PADDING_VERTICAL,
                paddingLeft: R.spacing.m,
                paddingRight: R.spacing.m,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  ...R.typography.weightMedium,
                  color: R.color.textPrimary,
                  fontSize: CONTENT_FONT_SIZE,
                  lineHeight: CONTENT_LINE_HEIGHT,
                }}
              >
                {hour}
              </Text>
            </Animated.View>
          );
        })}
      </SwipeableViews>
    );
  }
}

export default SwipeablePicker;
